import { render } from "./OrgAqsRedirect.vue?vue&type=template&id=2c1295cc&ts=true"
import script from "./OrgAqsRedirect.vue?vue&type=script&lang=ts"
export * from "./OrgAqsRedirect.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__